import { render, staticRenderFns } from "./VersionList.vue?vue&type=template&id=f1d628d6&scoped=true&"
import script from "./VersionList.vue?vue&type=script&lang=js&"
export * from "./VersionList.vue?vue&type=script&lang=js&"
import style0 from "./VersionList.vue?vue&type=style&index=0&id=f1d628d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d628d6",
  null
  
)

export default component.exports